import _Input from "@alifd/next/es/input";
import React from 'react';
import { isCssVarBind } from '../../utils';
var LayoutInput = function LayoutInput(props) {
  var value = props.value;
  if (isCssVarBind(value)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(_Input, props);
};
export default LayoutInput;